import { ProgressLoader } from '@g17eco/atoms/loader';
import { Button } from 'reactstrap';
import { FileWithAiProcessing } from '../../../../types/document';
import { ImportFileDropzone, FileDropzoneVariant } from '@features/files/ImportFileDropZone';
import { DocumentUploadItem } from './DocumentUploadItem';
import './DocumentUpload.scss';
import { SUPPORTED_FILE_TYPES_MESSAGE, SUPPORTED_MIME_TYPES } from './constants';

export interface DocumentUploadProps {
  isUploading: boolean;
  files: FileWithAiProcessing[];
  onFilesAdded: (files: File[]) => void;
  onToggleAiProcessing: (fileId: string) => void;
  onRemoveFile: (fileId: string) => void;
  onCancel: () => void;
  onUpload: () => void;
}

export const DocumentUpload = ({
  isUploading,
  files,
  onFilesAdded,
  onToggleAiProcessing,
  onRemoveFile,
  onCancel,
  onUpload,
}: DocumentUploadProps) => {
  if (isUploading) {
    return (
      <div className='text-center py-5'>
        <ProgressLoader />
        <span className='mt-2 d-block'>...uploading...</span>
      </div>
    );
  }

  return (
    <div className='document-upload'>
      <div className='upload-section-container d-flex flex-column align-items-center rounded-2 mb-4 p-3'>
        <div className='w-100'>
          <ImportFileDropzone
            variant={FileDropzoneVariant.Icon}
            importFile={undefined}
            accept={SUPPORTED_MIME_TYPES}
            onFilesAdded={onFilesAdded}
            multiple={true}
            hint={SUPPORTED_FILE_TYPES_MESSAGE}
          />
        </div>
        {files.length > 0 ? (
          <>
            <div className='instruction-text text-center text-muted my-3'>
              <p className='mb-1'>AI access to documents is on.</p>
              <p className='mb-1'>You can block it for specific documents by toggling off below:</p>
            </div>
            <div className='file-list d-flex flex-column gap-2'>
              {files.map((fileWithAi) => (
                <DocumentUploadItem
                  key={fileWithAi.id}
                  fileWithAi={fileWithAi}
                  onToggleAiProcessing={onToggleAiProcessing}
                  onRemoveFile={onRemoveFile}
                />
              ))}
            </div>
            <div className='action-buttons d-flex justify-content-end w-100 gap-2 mt-4 px-2'>
              <Button color='link-secondary' onClick={onCancel} disabled={isUploading}>
                Cancel
              </Button>
              <Button color='primary' onClick={onUpload} disabled={isUploading}>
                {isUploading ? 'Uploading...' : 'Upload documents'}
              </Button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};
